(function paycheckDetailControllerDefinition() {
    'use strict';

    angular.module('Paycheck')
        .controller('PaycheckDetailController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processCustomerService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', 'fileDownloader', '$window', 'alerts', '$translate', 'processService', 'adminOrganizationalUnitService',
            function paycheckDetailController($filter, $state, $scope, $stateParams, errors, processCustomerService, fileWorkflowService, auth, configViewService, $q, fileDownloader, $window, alerts, $translate, processService, adminOrganizationalUnitService) {
                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.movePaycheck = function (paycheck) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (paycheck.stateId === '116') {
                        processService.execute($stateParams.id).then(function (process) {
                            defered.resolve(process);
                        }, function (error) {
                            defered.reject(error);
                        });
                    } else {
                        defered.resolve(paycheck);
                    }

                    return promise;
                };

                $scope.setPaycheck = function (paycheck) {                    
                    if (paycheck) {
                        $scope.paycheck = paycheck;
                        return adminOrganizationalUnitService.getConfigs(paycheck.organizationalUnitId);
                    }
                };

                $scope.loadConfig = function (configs) {
                    if (!configs) {
                        return;
                    }

                    var paycheckType = $filter('filter')($scope.paycheck.metadataValues, { systemName: '_trec' }, true);
                    var defaultConfig = $filter('filter')(configs, { configName: '#OuConfigSectionPaychecks' }, true);
                    var config = $filter('filter')(configs, function (item) {
                        return paycheckType.length > 0 && item.configName === '#OuConfigRA' + paycheckType[0].value;
                    }, true);

                    if (config.length === 0) {
                        config = defaultConfig;
                    }

                    if (config.length > 0) {
                        var metadata = $filter('filter')(config[0].metatadataValues, { name: '#PaycheckMotiveDisagreement' }, true);
                        if (metadata.length > 0) {
                            $scope.showMotiveDisagreement = metadata[0].value === 'true';
                        }
                    }

                    return configViewService.getById('CPPPaycheck');
                };

                $scope.setConfig = function (configView) {
                    if (!configView) {
                        return;
                    }

                    $scope.configView = configView;
                    var metadatas = [];
                    var processType = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.paycheck.processTypeId }, true);
                    if (processType.length == 0) {
                        $scope.paycheck.metadataValues = metadatas;
                        return;
                    }

                    processType[0].metadatas.forEach(function (paycheckMetadata) {
                        if (paycheckMetadata.systemName === '_motivodisc' && !$scope.showMotiveDisagreement) {
                            return;
                        }

                        if (paycheckMetadata.detailCriteria) {
                            var metadataFound = $filter('filter')($scope.paycheck.metadataValues, { systemName: paycheckMetadata.systemName }, true);

                            var value = null;
                            var desc = null;

                            if (metadataFound.length > 0) {
                                value = metadataFound[0].value;
                                desc = metadataFound[0].description;
                            }

                            metadatas.push({
                                metadataId: paycheckMetadata.metadataId,
                                type: paycheckMetadata.metadataType != null ? paycheckMetadata.metadataType.toLowerCase() : undefined,
                                name: paycheckMetadata.detailCriteria.name,
                                isVisible: true,
                                maskOptions: paycheckMetadata.maskOptions,
                                systemName: paycheckMetadata.systemName,
                                order: paycheckMetadata.detailCriteria.order,
                                value: value,
                                description: desc,
                                mask: paycheckMetadata.detailCriteria.mask
                            });
                        }
                    });

                    metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.paycheck.metadataValues = metadatas;
                    $scope.loadActions(processType[0], $scope.paycheck);
                    var item = {};

                    $scope.paycheck.files.forEach(function (file) {
                        item.creationDate = file.creationDate;
                        item.name = file.name;
                        item.size = file.size;
                        item.id = file.id;
                        item.stream = null;
                    });

                    $scope.previewFile(item, 0);
                };

                $scope.showError = function (error) {
                    errors.showError(error);
                    $scope.cancel();
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item).then(function (result) {
                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        } else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.cancel = function () {
                    if ($scope.actions.edit && $scope.signPermission) {
                        $translate(['Warning', 'PaycheckSignWarning', 'Exit', 'PaycheckSign'])
                            .then(function (translated) {
                                alerts.confirm(translated.Warning, translated.PaycheckSignWarning, translated.PaycheckSign, translated.Exit).then(function (result) {
                                    if (result) {
                                        $scope.edit();
                                    } else {
                                        $state.go('paycheck-find');
                                    }
                                });
                            });
                    } else {
                        $state.go('paycheck-find');
                    }
                };

                $scope.edit = function () {

                    $state.go('paycheck-edit', { id: $scope.paycheck.id });
                };

                $scope.loadActions = function (processType, process) {
                    var result = $filter('filter')(processType.groupStates, function (item) {
                        return item.ids.indexOf(process.stateId) > -1;
                    }, true);

                    if (result.length > 0) {
                        $scope.actions = {
                            delete: result[0].delete,
                            edit: result[0].edit,
                            editName: 'PaycheckRRHH' + result[0].editName
                        };
                    }
                };

                $scope.load = function () {
                    $scope.actions = {
                        delete: false,
                        edit: false,
                        editName: 'Edit'
                    };

                    $scope.userId = auth.getUserId();
                    $scope.signPermission = auth.isInRole('PAYCHECKCUSTOMER SIGN');
                    $scope.showMotiveDisagreement = false;

                    processCustomerService.getById($stateParams.id)
                        .then($scope.movePaycheck, $scope.showError)
                        .then($scope.setPaycheck, $scope.showError)
                        .then($scope.loadConfig, $scope.showError)
                        .then($scope.setConfig, $scope.showError);
                };

                $scope.downloadFile = function () {
                    var metadata = {
                        nrolegValue: '',
                        periValue: '',
                        trecValue: ''
                    };
                    if ($scope.paycheck.files.length < 2) {
                        for (var i = 0; i < $scope.paycheck.metadataValues.length; i++) {
                            switch ($scope.paycheck.metadataValues[i].systemName) {
                                case '_nroleg': metadata.nrolegValue = $scope.paycheck.metadataValues[i].value; break;
                                case '_peri': metadata.periValue = $scope.paycheck.metadataValues[i].value; break;
                                case '_trec': metadata.trecValue = $scope.paycheck.metadataValues[i].value; break;
                            }
                        }

                        $scope.paycheck.files.forEach(function (file) {                            
                            return fileWorkflowService.customerDownload(file.id).then(function (result) {
                                var fileName = metadata.nrolegValue + ' - ' + metadata.periValue + ' - ' + metadata.trecValue + ' - ' + $scope.paycheck.stateAlias + ' [' + $scope.paycheck.files[0].creationDate.replace(/:/g, '.') + '].pdf';
                                var success = fileDownloader.saveAs(result, fileName);

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 204) {
                                    errors.showWarning('The document has no files');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                    } else {
                        var files = [];
                        $scope.paycheck.files.forEach(function (file) {
                            files.push({ id: file.id, name: file.name });
                        });

                        return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {

                            var success = fileDownloader.saveAs(result.value, $translate.instant('PaycheckAllFiles') + '.zip');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            if (error.status === 204) {
                                errors.showWarning('The document has no files');
                            } else {
                                errors.showError('Api failed');
                            }
                        });
                    }
                };

                $scope.load();
            }
        ]);
})();
